export default __webpack_public_path__ + "static/media/green-dui.f0666b81.svg";